import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css']
})
export class BackButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $(document).ready(function(){
      $('.tooltipped').tooltip({delay: 50});
    });
  }

  backToSearch() {
    $('.tooltipped').tooltip('remove');
    window.history.back();
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/inAppBack/back-button/back-button.component.ts